module.exports = __webpack_public_path__ + "img/ok1.e583034a.png";